<template>
  <div id="home-featured-carousel">
    <div id="podcasts-carousel" class="swiper-container">
      <div class="swiper-wrapper">
        <div v-for="slide in featuredData"
             :key="slide.id"
             class="swiper-slide"
        >
          <ShowCard :show-data="slide.podcasts" />
        </div>
      </div>
    </div>
    <div id="home-podcasts-carousel-prev" class="swiper-button-prev unset">
      <ArrowCarouselPrev />
    </div>
    <div id="home-podcasts-carousel-next" class="swiper-button-next">
      <ArrowCarouselNext />
    </div>
  </div>
</template>
<script>
import Swiper, { Navigation } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
Swiper.use(Navigation);

import ShowCard from '@/components/cards/ShowCard.vue';
import ArrowCarouselNext from '@/components/svg/ArrowCarouselNext.vue';
import ArrowCarouselPrev from '@/components/svg/ArrowCarouselPrev.vue';

export default {
  name: 'HomeFeaturedCarousel',
  components: {
    ShowCard,
    ArrowCarouselNext,
    ArrowCarouselPrev
  },
  props: {
    featuredData: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    carouselConfig: {
      freeMode: {
        enabled: true,
        sticky: true,
        momentum: false,
        momentumBounce: false
      },
      slidesPerGroup: 1,
      slidesPerView: 1.5,
      spaceBetween: 10,
      loop: false,
      simulateTouch: true,
      navigation: {
        nextEl: '#home-podcasts-carousel-next',
        prevEl: '#home-podcasts-carousel-prev'
      },
      breakpoints: {
        480: {
          slidesPerView: 2.5,
          spaceBetween: 10
        },
        640: {
          slidesPerView: 3.5,
          spaceBetween: 10,
          slidesPerGroup: 3
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 10,
          slidesPerGroup: 3
        }
      }
    }
  }),
  mounted() {
    this.$nextTick(() => {
      this.initCarousel();
    });
  },
  methods: {
    initCarousel() {
      new Swiper('#podcasts-carousel', this.carouselConfig);
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_home-featured-carousel.scss';
</style>
